export interface HttpErrorParams {
  name: string;
  message: string;
  status?: number;
  /** Chave de erro do backend (`application-exception-filter.ts`), ex.: `SCHEDULE_MISMATCH`. */
  code?: string;
  cause?: Error;
  formContext?: { field: string; identifier?: string };
  /** Contextos de formulário do back (`setFormContexts`): ids/sessões/lugares que explicam o erro. */
  formContexts?: Record<string, unknown>[];
}

export class HttpError extends Error {
  override name: string;
  status?: number;
  code?: string;
  cause?: Error;
  formContext?: { field: string; identifier?: string };
  formContexts?: Record<string, unknown>[];

  constructor({ name, message, status, code, cause, formContext, formContexts }: HttpErrorParams) {
    super(message);
    this.name = name;
    this.status = status;
    this.code = code;
    this.cause = cause;
    this.formContext = formContext;
    this.formContexts = formContexts;
  }
}
